/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_Slow_ReadInputs */

const en_loading_slow_read = /** @type {(inputs: Loading_Slow_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is taking longer than usual. Check your connection; we are still waiting for the response.`)
};

const id_loading_slow_read = /** @type {(inputs: Loading_Slow_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebih lama dari biasanya. Periksa koneksimu; kami masih menunggu respons.`)
};

/**
* | output |
* | --- |
* | "This is taking longer than usual. Check your connection; we are still waiting for the response." |
*
* @param {Loading_Slow_ReadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const loading_slow_read = /** @type {((inputs?: Loading_Slow_ReadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Slow_ReadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_loading_slow_read(inputs)
	return en_loading_slow_read(inputs)
});